import { PaginationStep as SwanPaginationStep } from '@vp/swan'

import { usePaginationLink } from '~/app/features/Gallery/hooks/usePaginationLink'
import { ComponentProps } from 'react'

export interface PropTypes extends ComponentProps<typeof SwanPaginationStep> {
  current?: boolean
  pageText: string
  pageNumber: number
}

export const PaginationStep = (props: PropTypes) => {
  const { current, pageText, pageNumber, ...restProps } = props

  const linkHref = usePaginationLink(pageNumber)

  return (
    <SwanPaginationStep active={!!current} aria-current={!!current} href={linkHref} {...restProps}>
      {pageText}
    </SwanPaginationStep>
  )
}

PaginationStep.displayName = 'PaginationStep'
